import Entity from './entity'

const Announcement = new Entity('announcements')

export default Announcement
